import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-control-error',
    templateUrl: './control-error.component.html',
    styleUrls: ['./control-error.component.scss']
})
export class ControlErrorComponent {
    @Input() control: FormControl;
}
